<div class="bloco conteudo bn-form-group" (click)="click()" [class.active]="animacaoBloco === 'modificado'" [@animacao-bloco]="animacaoBloco">

  <div class="cursor">
    <i class="fa fa-chevron-right" *ngIf="animacaoBlocoInterno === 'hidden'"></i>
    <i class="fa fa-chevron-down" *ngIf="animacaoBlocoInterno === 'visible'"></i>
  </div>
    <p class="title">
      {{title}}
    </p>

</div>

<div class="bloco-interno" [@animacao-bloco-interno]="animacaoBlocoInterno">
  <ng-content></ng-content>
</div>